import { Dialog, MenuItem } from '@mui/material';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { NotificationManager } from 'react-notifications';
import { Alert,  ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { getUserByRoleIdApi } from '../../../../api/user';
import { postSaveWebMessagesApi } from '../../../../api/webMessages';
import { getItemAssignedByProjectIdApi } from '../../../../api/coordinator/itemAssigned';
import config from '../../../../config';
import { getFullName } from '../../../../util/utilFunction';
import UserCell from './UserCell';

//import io from 'socket.io-client';

//const ENDPOINT ="https://testyaysis.ayk.gov.tr/api"
//config.apiUrl
// const socket = io.connect(config.appUrl , { 
//   transports: [
//      'websocket' ,
//      'polling',
//     // 'flashsocket'
//   ],
//   withCredentials: true

// })
 

function NewMessageModal({open, onClose, senderUser,receiverUser,newMessageType,selectedItem , isAuthorized,isInstitution, myProjects}) {
  const [body,setBody] = useState("");
  const [selectedProjectId,setSelectedProjectId] = useState(0);
  const [receiverUserId,setReceiverUserId] = useState(0);
  const [receiverUserList,setReceiverUserList] = useState([]);

  const [success,setSuccess] = useState(false);

  const [eMail,setEmail] = useState(false);
  const [sms,setSms] = useState(false);


  // useEffect(()=>{
  //   socket.on('message',({name,message})=>{

  //    //console.log("NewMessage dialog name message **** ",name,message )}
  //   )
  // })

  const sendMessage = async () =>{
    const selectedProject = myProjects?.find(p => p.id === selectedProjectId);
    
    const newMessage = 
    newMessageType === "detail" ? 
    {
      body,
      questionId:0, 
      isComplate:0,
      inst: selectedProject ? selectedProject.inst : senderUser.inst,
      senderUserId : senderUser.id,
      receiverUserId,
      journalId: selectedProject ? selectedProject.id : 0,
      itemId:selectedItem !== undefined ? selectedItem.id : -1,
      eMail,
      sms,
      receiverEmail : receiverUserList.find(x=>x.id === receiverUserId)?.email
      
    }
    :
    {
      body,
      questionId:0,
      isComplate:0,
      inst:senderUser.inst,
      senderUserId : senderUser.id,
      receiverUserId : receiverUser.id,
      itemId:selectedItem !== undefined ? selectedItem.id : -1,
      eMail,
      sms,
      receiverEmail : receiverUser.email

    }

   //console.log("new Mesaj ",newMessage)

    // socket.emit('message',{name:"Nurdoğan " + socket.id ,message : newMessage})

    const result  = await postSaveWebMessagesApi(newMessage);

   //console.log("result ",result);
    if(result.status)
    {
     // setSuccess(true)
     setBody("");
   //  setSuccess(false)
    onClose()

      NotificationManager.success(<IntlMessages id="webMessages.newMessageModal.successMessage"/>);
    }
  }

  const getReceiverList = async (projectId)=>{
    if (!projectId || projectId === 0) {
      setReceiverUserList([]);
      return;
    }
    
    // Projeye özel madde takip görevlilerini al
    const resultItemAssigned = await getItemAssignedByProjectIdApi(projectId);
    
    if(resultItemAssigned.status && resultItemAssigned.data && resultItemAssigned.data.length > 0) {
      // Unique editor'ları al (aynı editor birden fazla item'a atanmış olabilir)
      const uniqueEditors = [];
      const editorIds = new Set();
      
      resultItemAssigned.data.forEach(item => {
        if (item.editorId && !editorIds.has(item.editorId)) {
          editorIds.add(item.editorId);
          uniqueEditors.push({
            id: item.editorId,
            name: item.editorName?.split(' ')[1] || '',
            surname: item.editorName?.split(' ')[2] || '',
            title: item.editorName?.split(' ')[0] || '',
            email: item.email,
            profileImageUrl: item.profileImageUrl
          });
        }
      });
      
      setReceiverUserList(uniqueEditors);
    } else {
      setReceiverUserList([]);
    }
  }

  
  return (<div style={{zIndex:"1500 !important"}}>
  {/* <Modal className="modal-box modal-box-mail"   isOpen={open} id="newMessageModal"> */}
  <Dialog className="modal-box" maxWidth="md" fullWidth open={open}  onClose={onClose} >

      <ModalHeader className="modal-box-header bg-primary text-white">
      <IntlMessages id="webMessages.newMessageModal.title"/>
        <IconButton className="text-white"
                    onClick={onClose}>
          <CloseIcon/>
        </IconButton>
      </ModalHeader>
      <div className="modal-box-content d-flex flex-column">

         <UserCell user={senderUser} title={<IntlMessages id="webMessages.sender"/>} isAuthorized={true}/>
         {receiverUser !== null && <UserCell user={receiverUser} title={<IntlMessages id="webMessages.receiver"/>} isAuthorized={isAuthorized}/>}
        { newMessageType === "detail" &&
          <div className="row"> 
            <div className="col-md-6">
              <div className="form-group">
                <TextField
                  id="project"
                  select
                  label={<IntlMessages id="project" />}
                  value={selectedProjectId}
                  SelectProps={{}}
                  margin="normal"
                  fullWidth
                  onChange={(e)=>{
                    e.preventDefault();
                    const projectId = Number(e.target.value);
                    setSelectedProjectId(projectId);
                    getReceiverList(projectId);
                    setReceiverUserId(0);
                  }}
                >
                  {myProjects && myProjects.length > 0 ? (
                    myProjects.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value={0} disabled>
                      <IntlMessages id="webMessages.newMessageModal.noProject" />
                    </MenuItem>
                  )}
                </TextField>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <TextField
                  id="receiver"
                  select
                  label={<IntlMessages id="webMessages.receiver" />}
                  margin="normal" 
                  fullWidth
                  value={receiverUserId}
                  disabled={selectedProjectId === 0 || receiverUserList.length === 0}
                  onChange={(e)=>setReceiverUserId(Number(e.target.value))}
                >
                  {receiverUserList.length > 0 ? (
                    receiverUserList.map((option) => (
                      <MenuItem key={"key" + option.id} value={option.id}>
                        { getFullName(option)}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value={0} disabled>
                      Tanımlı alıcı bulunamadı!
                    </MenuItem>
                  )}
                </TextField>
              </div>
            </div>
          </div>
            }

            {
              isInstitution  ?
              <FormControl component="fieldset" className="m-3">
              <FormLabel component="legend"><IntlMessages id={"webMessages.newMessageModal.notificationType"} /></FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={eMail} onChange={(e)=>setEmail(e.target.checked)} name="gilad" />}
                  label={ <IntlMessages id={"webMessages.newMessageModal.eMail"} />}
                />
                <FormControlLabel 
                  control={<Checkbox disabled={ (isAuthorized && body.length >= 300) } checked={sms} onChange={(e)=>setSms(e.target.checked)}name="jason" />}
                  label={ <IntlMessages id={"webMessages.newMessageModal.sms"} />}
                />
               
              </FormGroup>
            </FormControl>

              : null 
            }
            {
              (isAuthorized && body.length >= 300) && <Alert color="danger">
                Toplamda 300 ve üzeri karakter sayısını geçtiğiniz için, mesajınızı SMS olarak gönderemezsiniz.
              </Alert>
            }
        <TextField
          id="required"
          label={ <IntlMessages id="webMessages.body"/>}
          onChange={(event) => {setBody(event.target.value); setSms(event.target.value.length>=300 ? false : sms);}}
          value={body}
          variant="outlined"
          multiline
          rows="5"
          rowsMax="20"
          margin="normal"/>
      </div>

      <div className="modal-box-footer">
        {/* <Button className="attach-file jr-btn text-muted">
          <i className="zmdi zmdi-attachment mr-2 zmdi-hc-2x"/> Attach File
        </Button> */}

        <Button disabled={body === ''} variant="contained" color="primary" onClick={() => {
          sendMessage();

        }}>
          <i className="zmdi zmdi-mail-send mr-2"/>  <IntlMessages id="webMessages.newMessageModal.sendMessage"/></Button>
      </div>

      <SweetAlert show={success} 
        success title={<IntlMessages id="webMessages.newMessageModal.successMessage"/>} 
        confirmBtnText={<IntlMessages id="button.ok"/>}
                    onConfirm={()=>{
                      setBody("");
                      setSuccess(false)
                     onClose()
                     
                    }
                      }>
                     
             </SweetAlert>

    {/* </Modal> */}
 </Dialog>
  </div>
   );
}

const mapStateToProps = ({item}) => {
  return {
    myProjects: item.myProjects || []
  };
};

export default connect(mapStateToProps)(NewMessageModal);


